<div class="row">
  <div class="reports-form-container">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="date_time" placeholder="Choose date" autocomplete="off" readonly [max]="maxDate"/>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div class="row tankmeal">
  <div class="row batchentry">
    <p>Batch Transaction Entry</p>
  </div>
  <div *ngIf="!responseLoader">
    <div class="adjust loader-container">
      <div class="loader2"></div>
    </div>
  </div>
  <div class="row eachcard" [ngClass]="{'eachcard' : pondsDetails_dropdown.length>2 }">
    <div class="row" *ngFor="let pondselect of pondsDetails_dropdown; let j = index;">
      <div class="row">
        <div class="buttons-div" *ngIf="j == 0 && noApplyAllPondsEditable" style="padding-bottom: 30px; padding-top: 30px">
          <div class="transactions-button-container">
            <button class="transaction-submit-button" (click)="applyToAllPonds(j);">
              <span class="text"><img src="assets/images/New_Icons/applytoallpond.svg" class="applytoponds">Apply to all ponds</span>
            </button>
          </div>
        </div>
        <div class="col-xs-2 history-top" *ngIf="j >= 1"></div>
      </div>
      <div class="row">
        <div class="row">
          <div class="panel-body table-responsive mealscard">
            <table class="table table-bordered table-striped text-center" cellspacing=" 0" width="100%">
              <thead>
              <tr [ngClass]="{'autofillClass': pondselect.Autofill == true}">
                <th>{{ pondselect.pond_name }}</th>
                <th>Feed Type</th>
                <th>Reason</th>
                <th style="width: 8%;">Quantity</th>
                <th>UOM</th>
                <th>Feed Mix</th>
                <th style="width: 8%;">Quantity</th>
                <th>UOM</th>
                <th style="width: 16%;">Check tray Given(Grams)</th>
                <th style="width: 16%;">Check tray Feed Consumed(Grams)</th>
                <th *ngIf="noCardDeleteEditable"><span (click)="removePond(j)" title="Delete Card"
                                                       class="deletebtn">x</span></th>
              </tr>
              <tr *ngFor="let row of pondselect.FeedLogs; let i = index;">
                <td *ngIf="noMealEditText"><span *ngIf="noAddIconEditable && i == 0" class="addbtnitemmaster"><i
                  (click)="addNewFeedLogButton(j)" class="fa fa-plus"></i></span><span> Meal {{ i + 1 }}</span>
                </td>
                <td *ngIf="!noMealEditText">
                  <p>Meal {{ i + 1 }}</p>
                </td>
                <td>
                  <select name="feedtype" [(ngModel)]="row.feedMeal.feedTypes[0].feed_item_id"
                          class="itemmasterdropdown" *ngIf="noFeedTypeEditable"
                          (change)="getFeedBusinessItemId(i,j); feedTypeName(i,j); getFeedTypeIdsUomData(i,j);">
                    <option value=-1>Select Feed Type</option>
                    <option value="{{(feed.id)}}" *ngFor="let feed of feedTypes">{{ feed.item_name }}</option>
                  </select>
                  <p *ngIf="!noFeedTypeEditable">{{
                      pondsDetails_dropdown[j].FeedLogs[i].feeditem_name ?
                        pondsDetails_dropdown[j].FeedLogs[i].feeditem_name : 'NA'
                    }}</p>
                </td>
                <td *ngIf="row.feedMeal.feedTypes[0].feed_item_id == 99">
                  <input type="text" name="reason" [(ngModel)]="row.feedMeal.skip_reason" *ngIf="noreasonEditable"
                         class="form-control" autocomplete="off">
                  <p *ngIf="!noreasonEditable">{{ row.feedMeal.skip_reason }}</p>
                </td>
                <td *ngIf="noreasonEditable && row.feedMeal.feedTypes[0].feed_item_id != 99"></td>
                <td *ngIf="!noreasonEditable && row.feedMeal.feedTypes[0].feed_item_id != 99"></td>
                <td>
                  <input type="text" name="ftypequantity" [(ngModel)]="row.feedMeal.feedTypes[0].feed_qty_given"
                         *ngIf="nogeedQtyEditable && row.feedMeal.feedTypes[0].feed_item_id != 99" class="form-control"
                         autocomplete="off" (keypress)="numberValidation($event)">
                  <p *ngIf="!nogeedQtyEditable">{{
                      row.feedMeal.feedTypes[0].feed_qty_given != null ?
                        row.feedMeal.feedTypes[0].feed_qty_given : 'NA'
                    }}</p>
                  <p style="border: 1px solid #ccc; padding: 8px 10px; border-radius: 4px;" class="disbledCls"
                     *ngIf="nogeedQtyEditable && (row.feedMeal.feedTypes[0].feed_item_id == 99)">
                    0</p>
                </td>
                <td>
                  <select name="uom" [(ngModel)]="row.feedMeal.feedTypes[0].feed_uom_id"
                          *ngIf="noUomEditable && (row.itemUom && row.itemUom.length != 1)"
                          (change)="getUomNameByUomId(i,j, row.feedMeal.feedTypes[0].feed_uom_id)"
                          class="itemmasterdropdown">
                    <option value=-1>Select UOM</option>
                    <option value="{{uom.id}}" *ngFor="let uom of row.itemUom">{{ uom.name }}</option>
                  </select>
                  <p *ngIf="!noUomEditable && (row.itemUom && row.itemUom.length > 1)">
                    {{ pondsDetails_dropdown[j].FeedLogs[i].name ? pondsDetails_dropdown[j].FeedLogs[i].name : 'NA' }}
                  </p>
                  <p style="border: 1px solid #ccc; padding: 8px 10px; border-radius: 4px;" class="disbledCls"
                     *ngIf="noUomEditable && (row.itemUom && row.itemUom.length == 1)">{{ row.itemUom[0].name }}</p>
                  <p *ngIf="!noUomEditable && (row.itemUom && row.itemUom.length == 1)">{{ row.itemUom[0].name }}</p>
                </td>
                <td>
                  <select name="mix_item_id" [ngClass]="{'disbledCls': row.feedMeal.feedTypes[0].feed_item_id == 99}"
                          [(ngModel)]="row.feedMeal.feedTypes[0].mix_item_id"
                          (change)="getFeedMixBusinessItemId(i,j); getFeedMixNameById(i,j);getFeedMixIdsUomData(i,j)"
                          *ngIf="noFeedMixTypeEditable" class="itemmasterdropdown disbledCls">
                    <option value=-1>Select Feed Mix</option>
                    <option value="{{mix.id}}" *ngFor="let mix of feedMix">{{ mix.item_name }}</option>
                  </select>
                  <p *ngIf="!noFeedMixTypeEditable && row.feedMeal.feedTypes[0].feed_item_id != 99">
                    {{
                      pondsDetails_dropdown[j].FeedLogs[i].mixitem_name ?
                        pondsDetails_dropdown[j].FeedLogs[i].mixitem_name : "NA"
                    }}
                  </p>
                  <p *ngIf="!noFeedMixTypeEditable && row.feedMeal.feedTypes[0].feed_item_id == 99">NA</p>
                </td>
                <td>
                  <input type="text" name="fmixquantity" (keypress)="numberValidation($event)"
                         [ngClass]="{'disbledCls': row.feedMeal.feedTypes[0].feed_item_id == 99}"
                         [(ngModel)]="row.feedMeal.feedTypes[0].mix_qty_given" *ngIf="noMixQtyEditable"
                         class="form-control disbledCls" autocomplete="off">
                  <p *ngIf="!noMixQtyEditable">{{
                      row.feedMeal.feedTypes[0].mix_qty_given ?
                        row.feedMeal.feedTypes[0].mix_qty_given : "NA"
                    }}</p>
                </td>
                <td>
                  <select name="mixuom" [ngClass]="{'disbledCls': row.feedMeal.feedTypes[0].feed_item_id == 99}"
                          [(ngModel)]="row.feedMeal.feedTypes[0].mix_uom_id" *ngIf="noMixUomEditable"
                          (change)="getMixUomNameByUomId(i,j)" class="itemmasterdropdown disbledCls">
                    <option value=-1>Select UOM</option>
                    <option value="{{uom.id}}" *ngFor="let uom of row.mixUom">{{ uom.name }}</option>
                  </select>
                  <p *ngIf="!noMixUomEditable && row.feedMeal.feedTypes[0].feed_item_id != 99">
                    {{ pondsDetails_dropdown[j].FeedLogs[i].mixuomname }}</p>
                  <p *ngIf="!noMixUomEditable && row.feedMeal.feedTypes[0].feed_item_id == 99">NA</p>
                </td>
                <td><input type="text" name="checktrygiven" [(ngModel)]="row.checkTray.check_tray_feed_given"
                           (keypress)="numberValidation($event)"
                           [ngClass]="{'disbledCls': row.feedMeal.feedTypes[0].feed_item_id == 99}" class="form-control"
                           *ngIf="nocheckFeedGivenEditable" autocomplete="off">
                  <p *ngIf="!nocheckFeedGivenEditable">{{
                      row.checkTray.check_tray_feed_given ?
                        row.checkTray.check_tray_feed_given : "NA"
                    }}</p>
                </td>
                <td><input type="text" name="checktryconsumed" [(ngModel)]="row.checkTray.check_tray_feed_consumed"
                           (keypress)="numberValidation($event)"
                           [ngClass]="{'disbledCls': row.feedMeal.feedTypes[0].feed_item_id == 99}" class="form-control"
                           *ngIf="nocheckFeedConsumedEditable" autocomplete="off">
                  <p *ngIf="!nocheckFeedConsumedEditable">{{
                      row.checkTray.check_tray_feed_consumed ?
                        row.checkTray.check_tray_feed_consumed : "NA"
                    }}</p>
                </td>
                <td *ngIf="noMealDeleteIconEditable"><span (click)="removeObj(i,j)" class="delete-icon"
                                                           title="Delete Meal"><img
                  src="assets/images/New_Icons/delete-icon.svg"></span>
                </td>
              </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="editButton && submitButton">
    <div class="buttons-div edit-commit-button">
      <div class="transactions-button-container">
        <button class="transaction-submit-button" *ngIf="editButton" (click)="feedLogEditIcon()"
                [ngClass]="!disableDownload && isCommitDisabled ? 'disbledCls' : ''">
          <span class="editicon"><img src="../../../../../../assets/images/New_Icons/edit.svg"></span>
          <span class="text">Edit</span>
        </button>
      </div>
      <div class="transactions-button-container">
        <button class="transaction-submit-button commit-button"
                [ngClass]="!disableDownload && isCommitDisabled ? 'disbledCls' : ''" *ngIf="submitButton"
                (click)="checkUOM();">
          <span class="commiticon"><img src="../../../../../../assets/images/New_Icons/commit.svg"></span>
          <span class="text">Commit</span>
        </button>
      </div>
    </div>
  </div>
  <div class="buttons-div preview-button-block" *ngIf="previewButton" style="padding-bottom: 30px;">
    <div class="transactions-button-container">
      <button class="transaction-submit-button preview-button" (click)="priviewButton()">
        <span class="icon"><img src="../../../../../../assets/images/New_Icons/preview.svg"></span>
        <span class="text">Preview</span>
      </button>
    </div>
  </div>
</div>
